<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="chapterNumber" id="_idParaDest-1">Contents</h1>
<p class="toc_h1"><a href="#/DesertBlues2">Harold and Enid</a></p>
<p class="center"><a href="#/DesertBlues3">Freeway Driving</a></p>
<p class="center"><a href="#/DesertBlues4">Starting Over</a></p>
<p class="center"><a href="#/DesertBlues5">A Temporary Arrangement</a></p>
<p class="center"><a href="#/DesertBlues6">Outside</a></p>
<p class="center"><a href="#/DesertBlues7">Sort of Telling It Like It Is</a></p>
<p class="center"><a href="#/DesertBlues8">Meetings</a></p>
<p class="center"><a href="#/DesertBlues9">Mourning After</a></p>
<p class="toc_h1"><a href="#/DesertBlues10">Harold and Enid and Abe</a></p>
<p class="center"><a href="#/DesertBlues11">Maybe It Wasn’t Necessary . . .</a></p>
<p class="center"><a href="#/DesertBlues12"> . . . After All</a></p>
<p class="center"><a href="#/DesertBlues13">Western Swing</a></p>
<p class="center"><a href="#/DesertBlues14">Goodnight Irene, Goodnight</a></p>
<p class="center"><a href="#/DesertBlues15">And All They Will Call You Will Be . . .</a></p>
<p class="toc_h1"><a href="#/DesertBlues16">Harold and Enid and Abe and Archie</a></p>
<p class="center"><a href="#/DesertBlues17">Feeling Tomorrow Like I Feel Today</a></p>
<p class="center"><a href="#/DesertBlues18">It Makes Me Think I’m on My Last Go ’Round</a></p>
<p class="toc_h1"><a href="#/DesertBlues19">Enid and Harold</a></p>
<p class="center"><a href="#/DesertBlues20">The Lifetime I’ve Wasted, The Love That I’ve Tasted</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DesertBlues-1.vue?121f29e5